import Typography from '@mui/material/Typography'

const style = {
    fontWeight: 600,
    fontSize: '1.75rem',
    pt: '0.25rem'
}

interface HeaderTypographyProps {
	content: string
}

export const HeaderTypography = (props: HeaderTypographyProps) => {
    const { content } = props
    return (
        <Typography variant="h4" sx={style}>{content}</Typography>
    )
}
